import React from "react";
import { useParams } from "react-router-dom";
import { vendors } from "../../data/vendors";
import PageHeading from "../../components/PageHeading";

const StatusTask = () => {
  const { id } = useParams();
  const vendor = vendors.find((v) => v.id === Number(id));

  if (!vendor) {
    console.error(`Vendor with ID ${id} not found.`); // Log error for debugging
    return <h2 className="p-4">Vendor Not Found</h2>;
  }

  return (
    <div className="container-fluid p-4">
      <PageHeading  pagename={`Status Task for ${vendor.name}`} />

      <div className="shadow bg-white rounded p-4 mb-4">
       <PageHeading pagename="Task Status Details" fontSize="20px" color="#333" />
        <p>Completed: {vendor.tasks.completed}</p>
        <p>In Progress: {vendor.tasks.inProgress}</p>
        <p>Remaining: {vendor.tasks.remaining}</p>
      </div>
    </div>
  );
};

export default StatusTask;